module.exports = __webpack_public_path__ + "static/media/prism - annotated DataCard layout.1b9c0aae.png";